import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IPayrollRates } from "../../interface/payrollShuttle";

export const getPayrollRates = async (
    token: string,
    setRates: (rates: IPayrollRates) => void,
    dispatch: Function,
    setError: Function
) => {
    try {
        const response = await axios.get(`${urlAPI}/payroll-rates/`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        setRates(response.data.message);
    } catch (error: any) {
        console.error(error);
        setError("Impossible de récupérer les taux de la navette de paie.");
        dispatch(showSnackbar("Erreur lors du chargement des taux.", "error"));
    }
};
